import { render, staticRenderFns } from "./CreateUpdateOrganizationAdminForm.vue?vue&type=template&id=c046465a&scoped=true&"
import script from "./CreateUpdateOrganizationAdminForm.vue?vue&type=script&lang=ts&"
export * from "./CreateUpdateOrganizationAdminForm.vue?vue&type=script&lang=ts&"
import style0 from "./CreateUpdateOrganizationAdminForm.vue?vue&type=style&index=0&id=c046465a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c046465a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
installComponents(component, {VCol,VDataTable,VRow,VSpacer,VStepperContent})
